"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.unionFlag = exports.UploadTracer = exports.getLocationPoiUpload = exports.getServiceLocation = exports.setServiceLocationCatch = exports.checkBrowser = exports.loadAddressByCityId = exports.loadAddressByLocation = exports.getLocationByIp = exports.setCatchLocation = exports.getCatchAddress = exports.setCatchAddress = exports.getLocation = exports.removeLocalStorageDF = exports.checkEnv = exports.getDDAuth = exports.getWXAuth = exports.getLocationByAlipayClient = exports.getLocationByDingTalk = exports.getLocationByBrowser = exports.getLocationByApp = exports.getDFLocationByWX = exports.BFD_appGetCityInfo = exports.ApiHttpHelper = exports.getParamsEncryption = exports.getSessionStorageDF = exports.setSessionStorageDF = exports.getLocalStorageDF = exports.setLocalStorageDF = exports.setDFCookie = exports.getDFCookie = exports.getUrlParams = exports.getUrlParamsByObject = exports.initAddressDF = void 0;
//@ts-nocheck
var df_hybrid_1 = __importDefault(require("df_hybrid"));
// 备注，兼容钉钉 -- 更新一下
var dd = (window === null || window === void 0 ? void 0 : window.dd) || require('dingtalk-jsapi');
var logKey = 'dflocationsdk_log';
var cacheKey = 'platform';
/**
 * 地址相关key
 */
var addressKeys = {
    /**
     * 是否是第一次写入
     */
    isFrist: cacheKey + '_frist',
    /**
     * 完整省市区
     */
    address: cacheKey + '_address',
    /**
     * 经纬度
     */
    location: cacheKey + '_location',
};
/**
 * 初始化城市信息
 * @param {*} isLocation 是否需要精准定位,默认false不需要
 * @param {*} isEN 是否英文版
 * @param {requestCallback} cb - 执行后回调.
 * @param {*} cityId 自定义城市
 */
var initAddressDF = function (isLocation, cb, isEN, cityId, readCatch) {
    var _a, _b;
    if (isLocation === void 0) { isLocation = false; }
    if (isEN === void 0) { isEN = false; }
    if (cityId === void 0) { cityId = ''; }
    if (readCatch === void 0) { readCatch = false; }
    return __awaiter(this, void 0, void 0, function () {
        var _env, addressRes, addressDetail, city, district, region, streetList, street, cacheAddress;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    // 精准定位
                    if (isLocation) {
                        try {
                            _env = checkEnv();
                            (0, exports.getLocation)(_env, function (val) {
                                // 缓存中不存在写入,存在忽略
                                if (val && val.type !== 'cache' && readCatch) {
                                    setSessionStorageDF(addressKeys === null || addressKeys === void 0 ? void 0 : addressKeys.location, JSON.stringify(val));
                                }
                                cb && cb(val);
                            }, readCatch);
                        }
                        catch (ex) {
                            console.log('精准定位' + _env + '整体异常', ex);
                            cb && cb(null);
                        }
                    }
                    console.log('addressDetail-----------------begin');
                    return [4 /*yield*/, getAddress(cityId)];
                case 1:
                    addressRes = _c.sent();
                    console.log('获取到城市信息', addressRes);
                    addressDetail = ((_a = addressRes === null || addressRes === void 0 ? void 0 : addressRes.Data) === null || _a === void 0 ? void 0 : _a.data) || null;
                    // 如果是缓存中读取直接返回
                    if (((_b = addressRes === null || addressRes === void 0 ? void 0 : addressRes.Data) === null || _b === void 0 ? void 0 : _b.type) === 'cache') {
                        oldAddressCompatible(addressDetail);
                        return [2 /*return*/, addressDetail];
                    }
                    if (!addressDetail) {
                        console.error('未解析到城市信息');
                        return [2 /*return*/, {
                                code: 111000111,
                            }];
                    }
                    city = addressDetail.city, district = addressDetail.district, region = addressDetail.region, streetList = addressDetail.streetList;
                    street = (streetList === null || streetList === void 0 ? void 0 : streetList.length) > 0 ? streetList[0] : null;
                    if (!street) {
                        console.error('地址信息中无街道信息', addressDetail);
                    }
                    cacheAddress = {
                        // 省份ID
                        provinceId: district === null || district === void 0 ? void 0 : district.id,
                        // 省份名称
                        provinceName: isEN ? district === null || district === void 0 ? void 0 : district.nameEn : district === null || district === void 0 ? void 0 : district.nameCh,
                        // 省份值
                        provinceNameValue: district === null || district === void 0 ? void 0 : district.nameCh,
                        // 城市ID
                        cityId: city === null || city === void 0 ? void 0 : city.id,
                        // 城市名称
                        cityName: isEN ? city === null || city === void 0 ? void 0 : city.nameEn : city === null || city === void 0 ? void 0 : city.nameCh,
                        // 城市值
                        cityNameValue: city === null || city === void 0 ? void 0 : city.nameEn,
                        // 区域ID
                        districtId: region === null || region === void 0 ? void 0 : region.id,
                        // 区域ID
                        regionId: region === null || region === void 0 ? void 0 : region.id,
                        // 区域名称
                        districtName: isEN ? region === null || region === void 0 ? void 0 : region.nameEn : region === null || region === void 0 ? void 0 : region.nameCh,
                        regionName: isEN ? region === null || region === void 0 ? void 0 : region.nameEn : region === null || region === void 0 ? void 0 : region.nameCh,
                        districtValue: region === null || region === void 0 ? void 0 : region.nameCh,
                        // 街道ID
                        streetId: street === null || street === void 0 ? void 0 : street.id,
                        // 街道名称
                        streetName: isEN ? street === null || street === void 0 ? void 0 : street.nameEn : street === null || street === void 0 ? void 0 : street.nameCh,
                        streetValue: street === null || street === void 0 ? void 0 : street.nameCh,
                    };
                    // 走兜底逻辑不写入缓存和持久化
                    if ((addressRes === null || addressRes === void 0 ? void 0 : addressRes.code) !== 111000111) {
                        setLocalStorageDF('dfAddress', JSON.stringify(cacheAddress));
                        oldAddressCompatible(cacheAddress);
                    }
                    return [2 /*return*/, __assign(__assign({}, cacheAddress), { code: addressRes === null || addressRes === void 0 ? void 0 : addressRes.code })];
            }
        });
    });
};
exports.initAddressDF = initAddressDF;
/**
 * 兼容历史逻辑
 */
function oldAddressCompatible(cacheAddress) {
    console.log('开始更新缓存', cacheAddress);
    try {
        var oldAddress = {
            provinceId: cacheAddress === null || cacheAddress === void 0 ? void 0 : cacheAddress.provinceId,
            provinceName: cacheAddress === null || cacheAddress === void 0 ? void 0 : cacheAddress.provinceName,
            name: cacheAddress === null || cacheAddress === void 0 ? void 0 : cacheAddress.cityName,
            cityName: cacheAddress === null || cacheAddress === void 0 ? void 0 : cacheAddress.cityName,
            cityId: cacheAddress === null || cacheAddress === void 0 ? void 0 : cacheAddress.cityId,
            regionId: cacheAddress === null || cacheAddress === void 0 ? void 0 : cacheAddress.regionId,
            regionName: cacheAddress === null || cacheAddress === void 0 ? void 0 : cacheAddress.regionName,
            streetId: cacheAddress === null || cacheAddress === void 0 ? void 0 : cacheAddress.streetId,
            streetName: cacheAddress === null || cacheAddress === void 0 ? void 0 : cacheAddress.streetName,
        };
        // 清除当前域名下address
        document.cookie = "address=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        // 商城
        setDFCookie('address', JSON.stringify(oldAddress), '.dongfangfuli.com');
        // 公共
        setDFCookie('city', cacheAddress === null || cacheAddress === void 0 ? void 0 : cacheAddress.cityId, '.dongfangfuli.com');
        // 公共
        setDFCookie('dffl_mall_city', cacheAddress === null || cacheAddress === void 0 ? void 0 : cacheAddress.cityId, '.dongfangfuli.com');
        // 百福得
        setDFCookie('appCity', "".concat(cacheAddress === null || cacheAddress === void 0 ? void 0 : cacheAddress.cityName, ",").concat(cacheAddress === null || cacheAddress === void 0 ? void 0 : cacheAddress.cityId), '.dongfangfuli.com');
        try {
            if (checkEnv() === 'maxApp' || checkEnv() === 'bfdApp') {
                BFD_changeAppAddress(cacheAddress === null || cacheAddress === void 0 ? void 0 : cacheAddress.cityName, cacheAddress === null || cacheAddress === void 0 ? void 0 : cacheAddress.cityId);
            }
            setTimeout(function () {
                changeServiceAddress(cacheAddress === null || cacheAddress === void 0 ? void 0 : cacheAddress.provinceId, cacheAddress === null || cacheAddress === void 0 ? void 0 : cacheAddress.cityId, cacheAddress === null || cacheAddress === void 0 ? void 0 : cacheAddress.regionId, cacheAddress === null || cacheAddress === void 0 ? void 0 : cacheAddress.streetId);
            }, 10);
        }
        catch (ex) {
            console.error('写入持久化异常', ex);
        }
    }
    catch (ex) {
        console.log('写入cookie异常', ex);
    }
}
/**
 * 初始化地址
 */
var getAddress = function (cityId) {
    var _a, _b, _c, _d, _e, _f;
    if (cityId === void 0) { cityId = ''; }
    return __awaiter(this, void 0, void 0, function () {
        var urlCity, addressCity, dfAddress, appCity, return_address, returnObj, isBfd, citys, _citys_Cookie, _cityId, citys1, citys2, _cityId, _address, citys, _cityId, citys1, citys2, _address, error_1;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    urlCity = getUrlParams('city');
                    addressCity = getDFCookie('address');
                    dfAddress = getLocalStorageDF('dfAddress');
                    appCity = getDFCookie('appCity');
                    return_address = null;
                    if (!cityId) return [3 /*break*/, 2];
                    return [4 /*yield*/, getAddressInfo('city', cityId)];
                case 1:
                    return_address = _g.sent();
                    return [3 /*break*/, 34];
                case 2:
                    if (!(urlCity && !checkFrist(urlCity))) return [3 /*break*/, 4];
                    // url中是否携带地址,检查这个地址是否是已经记录缓存过,如果缓存过了直接略过
                    console.log('城市统一定位 ---- url city');
                    setLocalStorageDF(addressKeys.isFrist, urlCity);
                    return [4 /*yield*/, getAddressInfo('city', urlCity)];
                case 3:
                    // 直接解析城市获取完整城市信息
                    return_address = _g.sent();
                    console.log('城市统一定位 ---- 读取URL城市解析', urlCity, return_address);
                    return [3 /*break*/, 34];
                case 4:
                    if (!dfAddress) return [3 /*break*/, 17];
                    returnObj = {
                        data: JSON.parse(dfAddress),
                        type: 'cache',
                    };
                    isBfd = getUrlParams('union');
                    if (!(checkEnv() === 'maxApp' || checkEnv() === 'bfdApp' || isBfd)) return [3 /*break*/, 13];
                    citys = void 0;
                    if (!(checkEnv() === 'maxApp' || checkEnv() === 'bfdApp')) return [3 /*break*/, 6];
                    return [4 /*yield*/, BFD_appGetCityInfo()];
                case 5:
                    citys = _g.sent();
                    return [3 /*break*/, 7];
                case 6:
                    _citys_Cookie = appCity === null || appCity === void 0 ? void 0 : appCity.split(',');
                    if ((_citys_Cookie === null || _citys_Cookie === void 0 ? void 0 : _citys_Cookie.length) >= 2) {
                        _cityId = void 0;
                        citys1 = +_citys_Cookie[0];
                        citys2 = +_citys_Cookie[1];
                        if (!Number.isNaN(citys1)) {
                            _cityId = citys1;
                        }
                        else if (!Number.isNaN(citys2)) {
                            _cityId = citys2;
                        }
                        citys = {
                            cityId: _cityId
                        };
                    }
                    _g.label = 7;
                case 7:
                    console.log('----dflocationsdk_log-兼容AppCity', citys, returnObj);
                    if (!citys) return [3 /*break*/, 11];
                    _cityId = citys === null || citys === void 0 ? void 0 : citys.cityId;
                    if (!(((_a = returnObj === null || returnObj === void 0 ? void 0 : returnObj.data) === null || _a === void 0 ? void 0 : _a.cityId) == _cityId)) return [3 /*break*/, 8];
                    return_address = { Data: returnObj };
                    return [3 /*break*/, 10];
                case 8: return [4 /*yield*/, getAddressInfo('city', _cityId || ((_b = returnObj === null || returnObj === void 0 ? void 0 : returnObj.data) === null || _b === void 0 ? void 0 : _b.cityId))];
                case 9:
                    // 直接解析城市获取完整城市信息
                    return_address = _g.sent();
                    _g.label = 10;
                case 10: return [3 /*break*/, 12];
                case 11:
                    return_address = { Data: returnObj };
                    _g.label = 12;
                case 12: return [3 /*break*/, 16];
                case 13:
                    _address = JSON.parse(addressCity);
                    if (!(((_c = returnObj === null || returnObj === void 0 ? void 0 : returnObj.data) === null || _c === void 0 ? void 0 : _c.cityId) === (_address === null || _address === void 0 ? void 0 : _address.cityId) || !(_address === null || _address === void 0 ? void 0 : _address.cityId))) return [3 /*break*/, 14];
                    return_address = { Data: returnObj };
                    return [3 /*break*/, 16];
                case 14: return [4 /*yield*/, getAddressInfo('city', _address === null || _address === void 0 ? void 0 : _address.cityId)];
                case 15:
                    // 直接解析城市获取完整城市信息
                    return_address = _g.sent();
                    _g.label = 16;
                case 16:
                    // return_address = { Data: returnObj }
                    console.log('城市统一定位 ---- 读取统一定位直接返回：', return_address);
                    return [3 /*break*/, 34];
                case 17:
                    if (!appCity) return [3 /*break*/, 22];
                    citys = appCity === null || appCity === void 0 ? void 0 : appCity.split(',');
                    if (!((citys === null || citys === void 0 ? void 0 : citys.length) >= 2)) return [3 /*break*/, 19];
                    _cityId = void 0;
                    citys1 = +citys[0];
                    citys2 = +citys[1];
                    if (!Number.isNaN(citys1)) {
                        _cityId = citys1;
                    }
                    else if (!Number.isNaN(citys2)) {
                        _cityId = citys2;
                    }
                    return [4 /*yield*/, getAddressInfo('city', _cityId)];
                case 18:
                    // 直接解析城市获取完整城市信息
                    return_address = _g.sent();
                    return [3 /*break*/, 21];
                case 19: return [4 /*yield*/, getAddressInfo('ip')];
                case 20:
                    // 无外部影响直接走ip获取城市
                    return_address = _g.sent();
                    return_address = __assign(__assign({}, return_address), { code: 111000111 });
                    _g.label = 21;
                case 21: return [3 /*break*/, 34];
                case 22:
                    if (!addressCity) return [3 /*break*/, 31];
                    _address = JSON.parse(addressCity);
                    if (!((_address === null || _address === void 0 ? void 0 : _address.provinceId) && (_address === null || _address === void 0 ? void 0 : _address.cityId) && (_address === null || _address === void 0 ? void 0 : _address.regionId))) return [3 /*break*/, 24];
                    return [4 /*yield*/, getAddressInfo('city', _address === null || _address === void 0 ? void 0 : _address.cityId)];
                case 23:
                    // 不直接采用cookie里面数据，用city调用接口从新查询一次，防止垃圾数据
                    return_address = _g.sent();
                    return [3 /*break*/, 30];
                case 24:
                    if (!(_address === null || _address === void 0 ? void 0 : _address.id)) return [3 /*break*/, 28];
                    return [4 /*yield*/, getAddressInfo('city', _address === null || _address === void 0 ? void 0 : _address.id)];
                case 25:
                    // 体检业务场景
                    return_address = _g.sent();
                    if (!!return_address) return [3 /*break*/, 27];
                    return [4 /*yield*/, getAddressInfo('ip')];
                case 26:
                    // 如果是垃圾数据，造成未解析到城市，通过IP从新获取
                    return_address = _g.sent();
                    return_address = __assign(__assign({}, return_address), { code: 111000111 });
                    _g.label = 27;
                case 27: return [3 /*break*/, 30];
                case 28: return [4 /*yield*/, getAddressInfo('ip')];
                case 29:
                    // 兜底
                    return_address = _g.sent();
                    return_address = __assign(__assign({}, return_address), { code: 111000111 });
                    _g.label = 30;
                case 30: return [3 /*break*/, 34];
                case 31:
                    _g.trys.push([31, 33, , 34]);
                    return [4 /*yield*/, getAddressInfo('ip')];
                case 32:
                    // 无外部影响直接走ip获取城市
                    return_address = _g.sent();
                    return_address = __assign(__assign({}, return_address), { code: 111000111 });
                    return [3 /*break*/, 34];
                case 33:
                    error_1 = _g.sent();
                    return_address = { code: 111000111 };
                    return [3 /*break*/, 34];
                case 34:
                    if (!(((_d = return_address === null || return_address === void 0 ? void 0 : return_address.Data) === null || _d === void 0 ? void 0 : _d.code) &&
                        ((_e = return_address === null || return_address === void 0 ? void 0 : return_address.Data) === null || _e === void 0 ? void 0 : _e.code) != 200 &&
                        !((_f = return_address === null || return_address === void 0 ? void 0 : return_address.Data) === null || _f === void 0 ? void 0 : _f.data))) return [3 /*break*/, 36];
                    return [4 /*yield*/, getAddressInfo('city', 145)];
                case 35:
                    return_address = _g.sent();
                    return_address = __assign(__assign({}, return_address), { code: 111000111 });
                    _g.label = 36;
                case 36: 
                // try {
                //   if (return_address?.Data?.data && return_address?.code !== 111000111) {
                //     const { city, district, region, streetList } = {
                //       ...return_address?.Data?.data,
                //     }
                //     if (district && city && region && streetList) {
                //       const streetId = streetList?.length > 0 ? streetList[0].id : ''
                //       changeServiceAddress(district.id, city.id, region.id, streetId)
                //     }
                //   }
                // } catch (ex) {
                //   console.log('写入持久化异常', ex)
                // }
                return [2 /*return*/, return_address];
            }
        });
    });
};
/**
 * 回调方法.
 *
 * @callback requestCallback
 * @param {number} responseCode 200 表示执行成功
 * @param {string} responseMessage 信息
 * @param {object} data 返回执行成功结果对象
 */
/**
 * 获取完整城市信息
 * @param {string} type - ip 代表后台根据用户发送IP定位城市
 * @param {string} type - city 代表后台根据东福城市ID查询城市
 * @param {number} cityId 枚举为city时必填
 * @returns Promise
 */
function getAddressInfo(type, cityId) {
    if (type === void 0) { type = 'ip' | 'city'; }
    if (cityId === void 0) { cityId = ''; }
    return __awaiter(this, void 0, void 0, function () {
        var params, api, secretKey, cardCountParams, params, api, secretKey, cardCountParams;
        return __generator(this, function (_a) {
            try {
                params = {};
                switch (type) {
                    case 'city':
                        params = { cityId: cityId };
                        break;
                    case 'ip':
                        // ip定位不需要
                        params = {};
                        break;
                    default:
                        break;
                }
                api = new ApiHttpHelper();
                secretKey = 'XCwAjoB4';
                cardCountParams = getParamsEncryption(params, '100060', secretKey);
                return [2 /*return*/, api.Post2('/gw/app/position/external/getAddressInfo', cardCountParams)];
            }
            catch (error) {
                params = { cityId: 145 };
                api = new ApiHttpHelper();
                secretKey = 'XCwAjoB4';
                cardCountParams = getParamsEncryption(params, '100060', secretKey);
                return [2 /*return*/, api.Post2('/gw/app/position/external/getAddressInfo', cardCountParams)];
            }
            return [2 /*return*/];
        });
    });
}
/**
 * 更新服务端地址
 * @param {*} districtId 省
 * @param {*} cityId 市
 * @param {*} regionId 区
 * @param {*} streetId 街道
 * @returns
 */
function changeServiceAddress(districtId, cityId, regionId, streetId) {
    var api = new ApiHttpHelper();
    var params = {
        districtId: districtId,
        cityId: cityId,
        regionId: regionId,
        streetId: streetId,
    };
    return api.Post('/df-gw/location/lbs/updatecurrentcity', params);
}
/**
 * 更新服务器地址信息
 * @param {number} cityId 城市ID
 * @returns Promise
 */
function changeServiceCity(cityId) {
    if (cityId === void 0) { cityId = ''; }
    return __awaiter(this, void 0, void 0, function () {
        var params, api;
        return __generator(this, function (_a) {
            if (cityId === '') {
                return [2 /*return*/, null];
            }
            try {
                params = { cityId: cityId };
                api = new ApiHttpHelper();
                return [2 /*return*/, api.Post('/df-gw/location/lbs/updatecurrentcity', params)];
            }
            catch (error) {
                console.error('更新城市持久化失败');
            }
            return [2 /*return*/];
        });
    });
}
function checkFrist(city) {
    // 如果城市在缓存内存在说明已经记录过,直接忽略
    var val = getLocalStorageDF(addressKeys.isFrist);
    return val === city;
}
/**
 * 根据对象解析成url参数
 * @param params 参数对象
 */
function getUrlParamsByObject(params) {
    if (typeof params === 'undefined' || params === null) {
        return '';
    }
    else if (typeof params === 'string') {
        return params;
    }
    else {
        var keys = Object.keys(params);
        var urlParams_1 = '';
        keys.map(function (key) {
            urlParams_1 += "&".concat(key, "=").concat(params[key]);
        });
        return urlParams_1;
    }
}
exports.getUrlParamsByObject = getUrlParamsByObject;
/**
 * 获取请求参数名对应的值
 * @param  {String} name 参数名字
 * @return {String}
 */
function getUrlParams(name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    var res = window.location.search.substr(1).match(reg);
    if (res !== null)
        return window.decodeURIComponent(res[2]);
    return '';
}
exports.getUrlParams = getUrlParams;
/**
 * 获取cookie值
 * @param {*} cookieName - key
 * @returns string
 */
function getDFCookie(cookieName) {
    var cookieString = document.cookie;
    var start = cookieString.indexOf(cookieName + '=');
    // 加上等号的原因是避免在某些 Cookie 的值里有
    // 与 cookieName 一样的字符串。
    if (start == -1)
        // 找不到
        return null;
    start += cookieName.length + 1;
    var end = cookieString.indexOf(';', start);
    if (end == -1)
        return unescape(cookieString.substring(start));
    return unescape(cookieString.substring(start, end));
}
exports.getDFCookie = getDFCookie;
/**
 * 写入cookie
 * @param {*} name 写入key
 * @param {*} value 写入value
 * @param {*} domain 指定域名 默认当前域名
 * @param {*} path 路径 默认/
 */
function setDFCookie(name, value, domain, path) {
    var cookie = name + '=' + encodeURIComponent(value); //设置Cookie的名称和Cookie的值，Cookie名称为必填项。
    //设置Cookie的路径，默认为 /
    if (!path) {
        cookie += ';path=/';
    }
    //设置Cookie的存储域，默认为当前js执行的网页的域
    if (domain) {
        cookie += ';domain=' + domain;
    }
    // 设置过期时间
    var d = new Date();
    d.setTime(d.getTime() + 30 * 24 * 60 * 60 * 1000);
    var expires = 'expires=' + d.toUTCString();
    cookie += ';' + expires;
    document.cookie = cookie;
}
exports.setDFCookie = setDFCookie;
/**
 * 写入缓存
 * @param key 键
 * @param value 值
 */
function setLocalStorageDF(key, value) {
    var _win = window;
    _win.localStorage.setItem(key, value);
}
exports.setLocalStorageDF = setLocalStorageDF;
/**
 * 读取缓存
 * @param key 键
 */
function getLocalStorageDF(key) {
    var _win = window;
    return _win.localStorage.getItem(key);
}
exports.getLocalStorageDF = getLocalStorageDF;
/**
 * 写入缓存
 * @param key 键
 * @param value 值
 */
function setSessionStorageDF(key, value) {
    var _win = window;
    _win.sessionStorage.setItem(key, value);
}
exports.setSessionStorageDF = setSessionStorageDF;
/**
 * 读取缓存
 * @param key 键
 */
function getSessionStorageDF(key) {
    var _win = window;
    return _win.sessionStorage.getItem(key);
}
exports.getSessionStorageDF = getSessionStorageDF;
/**
 * 浏览器关闭,释放
 */
window.onbeforeunload = function () {
    var n = window.event.screenX - window.screenLeft;
    var b = n > document.documentElement.scrollWidth - 20;
    var _win = window;
    if ((b && window.event.clientY < 0) || window.event.altKey) {
        // 关闭浏览器清空缓存
        _win.localStorage.clear();
        // 清除cookie
        document.cookie
            .split(';')
            .forEach(function (cookie) {
            return (document.cookie = cookie
                .replace(/^ +/, '')
                .replace(/=.*/, "=;expires=".concat(new Date(0).toUTCString(), ";path=/")));
        });
    }
};
/* eslint-disable */
function encodeUTF8(s) {
    var i;
    var r = [];
    var c;
    var x;
    for (i = 0; i < s.length; i++)
        if ((c = s.charCodeAt(i)) < 0x80)
            r.push(c);
        else if (c < 0x800)
            r.push(0xc0 + ((c >> 6) & 0x1f), 0x80 + (c & 0x3f));
        else {
            if ((x = c ^ 0xd800) >> 10 == 0)
                // 对四字节UTF-16转换为Unicode
                (c = (x << 10) + (s.charCodeAt(++i) ^ 0xdc00) + 0x10000),
                    r.push(0xf0 + ((c >> 18) & 0x7), 0x80 + ((c >> 12) & 0x3f));
            else
                r.push(0xe0 + ((c >> 12) & 0xf));
            r.push(0x80 + ((c >> 6) & 0x3f), 0x80 + (c & 0x3f));
        }
    return r;
}
/**
 * 字符串加密成 hex 字符串
 * @param {*} s
 * @returns
 */
function sha1(s) {
    var data = new Uint8Array(encodeUTF8(s));
    var i;
    var j;
    var t;
    var l = (((data.length + 8) >>> 6) << 4) + 16;
    var s = new Uint8Array(l << 2);
    s.set(new Uint8Array(data.buffer)), (s = new Uint32Array(s.buffer));
    for (t = new DataView(s.buffer), i = 0; i < l; i++)
        s[i] = t.getUint32(i << 2);
    s[data.length >> 2] |= 0x80 << (24 - (data.length & 3) * 8);
    s[l - 1] = data.length << 3;
    var w = [];
    var f = [
        function () {
            return (m[1] & m[2]) | (~m[1] & m[3]);
        },
        function () {
            return m[1] ^ m[2] ^ m[3];
        },
        function () {
            return (m[1] & m[2]) | (m[1] & m[3]) | (m[2] & m[3]);
        },
        function () {
            return m[1] ^ m[2] ^ m[3];
        },
    ];
    var rol = function (n, c) {
        return (n << c) | (n >>> (32 - c));
    };
    var k = [1518500249, 1859775393, -1894007588, -899497514];
    var m = [1732584193, -271733879, null, null, -1009589776];
    (m[2] = ~m[0]), (m[3] = ~m[1]);
    for (i = 0; i < s.length; i += 16) {
        var o = m.slice(0);
        for (j = 0; j < 80; j++)
            (w[j] =
                j < 16
                    ? s[i + j]
                    : rol(w[j - 3] ^ w[j - 8] ^ w[j - 14] ^ w[j - 16], 1)),
                (t =
                    (rol(m[0], 5) + f[(j / 20) | 0]() + m[4] + w[j] + k[(j / 20) | 0]) |
                        0),
                (m[1] = rol(m[1], 30)),
                m.pop(),
                m.unshift(t);
        for (j = 0; j < 5; j++)
            m[j] = (m[j] + o[j]) | 0;
    }
    t = new DataView(new Uint32Array(m).buffer);
    for (var i = 0; i < 5; i++)
        m[i] = t.getUint32(i << 2);
    var hex = Array.prototype.map
        .call(new Uint8Array(new Uint32Array(m).buffer), function (e) {
        return (e < 16 ? '0' : '') + e.toString(16);
    })
        .join('');
    return hex.toUpperCase();
}
/**
 * 请求加密
 * @param {*} params 参数
 * @param {*} appid 应用ID
 * @param {*} secretKey 加密编码
 */
function getParamsEncryption(params, appid, secretKey, union) {
    if (union === void 0) { union = null; }
    var apiParams = {
        appId: appid,
        msgId: '4ac05cd2-1ee2-409a-8f44-517bb10faadf',
        timestamp: +new Date(),
        version: '1.0.1',
        body: JSON.stringify(params),
        sign: '',
    };
    if (union) {
        apiParams.union = union;
    }
    apiParams.sign = sha1(secretKey + apiParams.body + secretKey);
    return apiParams;
}
exports.getParamsEncryption = getParamsEncryption;
var ApiHttpHelper = /** @class */ (function () {
    function ApiHttpHelper(isMock) {
        if (isMock === void 0) { isMock = false; }
        this.isMock = false;
        this.bodyHandler = function (params, applicationType) {
            if (applicationType === void 0) { applicationType = true; }
            var unionParams = {};
            if (typeof params === 'undefined' || params === null) {
                if (applicationType) {
                    return "platform=1";
                }
                else {
                    unionParams.platform = 1;
                    return JSON.stringify(unionParams);
                }
            }
            else if (typeof params === 'string') {
                return params + "&platform=1";
            }
            else {
                unionParams = Object.assign(unionParams, params);
                unionParams.platform = 1;
                if (applicationType) {
                    return convertParam(unionParams);
                }
                else {
                    return JSON.stringify(unionParams);
                }
            }
        };
        /**写入header */
        this.setHeader = function (objs, xhr, applicationType) {
            if (applicationType === void 0) { applicationType = true; }
            var application = '';
            if (applicationType) {
                application = 'application/x-www-form-urlencoded;';
            }
            else {
                application = 'application/json;';
            }
            xhr.setRequestHeader('content-Type', "".concat(application));
            if (!objs) {
                return xhr;
            }
            var keys = Object.keys(objs);
            keys.map(function (key) {
                var val = objs[key];
                xhr.setRequestHeader(key, val);
            });
            return xhr;
        };
        /**请求地址处理处理 */
        this.urlHandler = function (apiUrl) {
            var c = new Date();
            if (apiUrl.indexOf('?') < 0) {
                apiUrl += "?timestamp=".concat(c.getTime());
            }
            else {
                apiUrl += "&timestamp=".concat(c.getTime());
            }
            // if (apiUrl.indexOf('http') > -1 || apiUrl.indexOf('https') > -1) {
            // return apiUrl;
            // } else {
            // return basic_url + apiUrl;
            return apiUrl;
            // }
        };
        this.isMock = isMock;
    }
    ApiHttpHelper.prototype.Get = function (url, params, headers, async) {
        var _this = this;
        if (async === void 0) { async = true; }
        return new Promise(function (resolve, reject) {
            var _a;
            var item = {
                Status: -1,
            };
            if (process.env.apiType === 'mock' || _this.isMock) {
                var time = parseInt((Math.random() * 4000).toString());
                setTimeout(function () {
                    resolve(item);
                }, time);
                return;
            }
            try {
                var xhr_1 = new XMLHttpRequest();
                xhr_1.open('get', _this.urlHandler(url) + getUrlParamsByObject(params), async);
                _this.setHeader(__assign(__assign({}, headers), (_a = window === null || window === void 0 ? void 0 : window.__df_channel_sdk) === null || _a === void 0 ? void 0 : _a.getRequestHeader()), xhr_1);
                xhr_1.send();
                if (async) {
                    xhr_1.onreadystatechange = function (e) {
                        if (xhr_1.readyState === 4) {
                            if (xhr_1.status === 200) {
                                item.Status = xhr_1.status;
                                var obj = void 0;
                                try {
                                    obj = JSON.parse(xhr_1.responseText);
                                }
                                catch (_a) {
                                    obj = xhr_1.responseText;
                                }
                                item.Data = obj;
                                resolve(item);
                            }
                            else {
                                reject(item);
                            }
                        }
                    };
                }
                else {
                    item.Status = xhr_1.status;
                    if (xhr_1.status === 200) {
                        item.Data = _this.strToJson(xhr_1.responseText);
                        resolve(item);
                    }
                    else {
                        reject(item);
                    }
                }
            }
            catch (e) {
                item.Message = e.message;
                reject(item);
            }
        });
    };
    ApiHttpHelper.prototype.Post = function (url, params, applicationType, headers, async) {
        var _this = this;
        if (applicationType === void 0) { applicationType = false; }
        if (async === void 0) { async = true; }
        return new Promise(function (resolve, reject) {
            var _a;
            var item = {
                Status: -1,
            };
            try {
                var xhr_2 = new XMLHttpRequest();
                // 携带cookie
                xhr_2.withCredentials = true;
                xhr_2.open('POST', _this.urlHandler(url), async);
                xhr_2 = _this.setHeader(__assign(__assign({}, headers), (_a = window === null || window === void 0 ? void 0 : window.__df_channel_sdk) === null || _a === void 0 ? void 0 : _a.getRequestHeader()), xhr_2, applicationType);
                // console.log(this.bodyHandler(params, applicationType),this.urlHandler(url))
                xhr_2.send(_this.bodyHandler(params, applicationType));
                item.Status = xhr_2.status;
                if (async) {
                    xhr_2.onreadystatechange = function (e) {
                        if (xhr_2.readyState === 4) {
                            var obj = void 0;
                            try {
                                obj = JSON.parse(xhr_2.responseText);
                            }
                            catch (_a) {
                                obj = xhr_2.responseText;
                            }
                            if (xhr_2.status === 200) {
                                item.Data = obj;
                                resolve(item);
                            }
                            else {
                                item.Status = xhr_2.status;
                                if (xhr_2.status === 200) {
                                    var obj_1 = obj_1;
                                    if (typeof obj_1 === 'object') {
                                        item.Data = obj_1.body ? obj_1.body : obj_1;
                                        item.Status = obj_1.respCode ? obj_1.respCode : obj_1.code;
                                        item.Message = obj_1.respMsg ? obj_1.respMsg : obj_1.msg;
                                    }
                                    else {
                                        item.Data = obj_1;
                                    }
                                    resolve(item);
                                }
                                else {
                                    reject(item);
                                }
                            }
                        }
                    };
                }
                else {
                    item.Status = xhr_2.status;
                    if (xhr_2.status === 200) {
                        var obj = _this.strToJson(xhr_2.responseText);
                        if (typeof obj === 'object') {
                            item.Data = obj.body ? obj.body : obj;
                            item.Status = obj.respCode ? obj.respCode : obj.code;
                            item.Message = obj.respMsg ? obj.respMsg : obj.msg;
                        }
                        else {
                            item.Data = obj;
                        }
                        resolve(item);
                    }
                    else {
                        reject(item);
                    }
                }
            }
            catch (e) {
                item.Message = e.message;
                reject(item);
            }
        });
    };
    ApiHttpHelper.prototype.Post2 = function (url, params, applicationType, headers, async) {
        var _this = this;
        if (applicationType === void 0) { applicationType = false; }
        if (async === void 0) { async = false; }
        return new Promise(function (resolve, reject) {
            var _a;
            var item = {
                Status: -1,
            };
            try {
                var xhr = new XMLHttpRequest();
                // 携带cookie
                xhr.withCredentials = true;
                xhr.open('POST', _this.urlHandler(url), async);
                xhr = _this.setHeader(__assign(__assign({}, headers), (_a = window === null || window === void 0 ? void 0 : window.__df_channel_sdk) === null || _a === void 0 ? void 0 : _a.getRequestHeader()), xhr, applicationType);
                // console.log(this.bodyHandler(params, applicationType),this.urlHandler(url))
                xhr.send(_this.bodyHandler(params, applicationType));
                item.Status = xhr.status;
                if (xhr.status === 200) {
                    var obj = _this.strToJson(xhr.responseText);
                    if (typeof obj === 'object') {
                        item.Data = obj.body ? obj.body : obj;
                        item.Status = obj.respCode ? obj.respCode : obj.code;
                        item.Message = obj.respMsg ? obj.respMsg : obj.msg;
                    }
                    else {
                        item.Data = obj;
                    }
                    resolve(item);
                }
                else {
                    reject(item);
                }
            }
            catch (e) {
                item.Message = e.message;
                reject(item);
            }
        });
    };
    ApiHttpHelper.prototype.strToJson = function (str) {
        try {
            return JSON.parse(str);
        }
        catch (_a) {
            return str;
        }
    };
    return ApiHttpHelper;
}());
exports.ApiHttpHelper = ApiHttpHelper;
function BFD_appGetGpsLoc(callBack) {
    try {
        console.log('appLocation调用app');
        df_hybrid_1.default.DFWLocation.appGetGpsLoc(function (respData) {
            console.log('appLocation回调', respData);
            var locat = null;
            if (respData.data && respData.data.longitude && respData.data.latitude) {
                locat = {
                    lng: respData.data.longitude,
                    lat: respData.data.latitude,
                };
            }
            callBack && callBack(locat);
            return location;
        });
    }
    catch (e) {
        console.log('获取APP经纬度异常', e);
        callBack && callBack(null);
        return {};
    }
}
function BFD_changeAppAddress(city, cityId) {
    console.log("city".concat(city, ",cityId").concat(cityId));
    try {
        var params = {
            city: city,
            cityId: cityId, //城市id    必填
        };
        window.dfwAppclass.DFWCity.appSwitchCityInfo(params, function (respData) {
            var infoStr = JSON.stringify(respData);
            console.log('appRelogin', infoStr);
        });
    }
    catch (e) {
        console.log('更改原生地址异常', e);
        return false;
    }
    return true;
}
function BFD_appGetCityInfo() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            try {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        df_hybrid_1.default.DFWCity.appGetCityInfo(function (respData) {
                            var _a, _b;
                            if ((respData === null || respData === void 0 ? void 0 : respData.code) == '0' && (respData === null || respData === void 0 ? void 0 : respData.data)) {
                                var item = {
                                    cityId: (_a = respData === null || respData === void 0 ? void 0 : respData.data) === null || _a === void 0 ? void 0 : _a.cityId,
                                    name: (_b = respData === null || respData === void 0 ? void 0 : respData.data) === null || _b === void 0 ? void 0 : _b.city,
                                };
                                console.log('----dflocationsdk_log-BFD_appGetCityInfo', item);
                                resolve(item);
                            }
                            else {
                                resolve(null);
                            }
                        });
                    })];
            }
            catch (e) {
                console.log('更改原生地址异常', e);
                return [2 /*return*/, null];
            }
            return [2 /*return*/];
        });
    });
}
exports.BFD_appGetCityInfo = BFD_appGetCityInfo;
/**
 * 计算时间差,返回对象
 * @param startTime 开始时间
 * @returns
 */
var sumTime = function (timeStart) {
    var timeEnd = Date.now();
    var val = timeEnd - timeStart;
    return { timeStart: timeStart, timeEnd: timeEnd, timeDuration: val };
};
/**
 * 终端判断
 * @returns
 */
var checkTerminal = function () {
    var userAgent = navigator.userAgent;
    var isiOS = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    var isAndroid = userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1;
    var str = '';
    if (isiOS) {
        str = 'ios';
    }
    else if (isAndroid) {
        str = 'android';
    }
    else {
        str = 'other';
    }
    return { currentTerminal: str };
};
/**
 * 获取微信定位
 * @param initWXConfig 是否要注册微信config,默认false
 */
var getDFLocationByWX = function (initWXConfig) {
    if (initWXConfig === void 0) { initWXConfig = false; }
    return new Promise(function (resolve, reject) {
        var startTime = Date.now();
        if (initWXConfig) {
            (0, exports.getWXAuth)().then(function (e) {
                (0, exports.UploadTracer)(null, { msg: "getDFLocationByWX - \u5FAE\u4FE1\u9274\u6743\u63A5\u53E3", data: JSON.stringify(e) }, startTime);
                if (e.code === 0) {
                    wx.ready(function () {
                        getWXLocationAuth(resolve, startTime);
                    });
                }
                else {
                    console.error('获取微信鉴权失败');
                    resolve({ code: -1 });
                    return;
                }
            });
        }
        else {
            wx.ready(function () {
                console.log(' wx.ready');
                getWXLocationAuth(resolve, startTime);
            });
            wx.error(function (res) {
                (0, exports.UploadTracer)(null, {
                    msg: "getDFLocationByWX - \u5FAE\u4FE1error",
                    data: JSON.stringify(res),
                    type: 'error',
                }, startTime);
                resolve({ code: -1 });
                console.log('微信授权失败', res);
            });
        }
    });
};
exports.getDFLocationByWX = getDFLocationByWX;
function getWXLocationAuth(resolve, startTime) {
    wx.getLocation({
        type: 'gcj02',
        success: function (res) {
            var location = {
                lat: res.latitude,
                lng: res.longitude,
            };
            var wxData = { code: 0, location: location };
            (0, exports.UploadTracer)(null, {
                msg: "getDFLocationByWX - \u5FAE\u4FE1success",
                data: JSON.stringify(wxData),
            }, startTime);
            resolve(wxData);
        },
        cancel: function (res) {
            (0, exports.UploadTracer)(null, { msg: "getDFLocationByWX - \u5FAE\u4FE1cancel", data: JSON.stringify(res) }, startTime);
            resolve({ code: -1 });
            console.log('微信拒绝授权', res);
        },
        fail: function (res) {
            (0, exports.UploadTracer)(null, { msg: "getDFLocationByWX - \u5FAE\u4FE1fail", data: JSON.stringify(res) }, startTime);
            resolve({ code: -1 });
            console.log('微信授权失败', res);
        },
    });
}
/**
 * 获取app经纬度
 */
var getLocationByApp = function () {
    return new Promise(function (resolve, reject) {
        var startTime = Date.now();
        BFD_appGetGpsLoc(function (data) {
            (0, exports.UploadTracer)(null, { msg: "getLocationByApp - App\u56DE\u8C03", data: JSON.stringify(data) }, startTime);
            if (data) {
                console.log('定位成功!', data);
                resolve({ code: 0, location: data });
            }
            else {
                resolve({ code: -1 });
                console.log('获取app定位失败');
            }
        });
    });
};
exports.getLocationByApp = getLocationByApp;
/**
 * 获取浏览器定位
 * @returns {Promise} Promise
 */
var getLocationByBrowser = function () {
    return new Promise(function (resolve, reject) {
        var startTime = Date.now();
        if (!navigator.geolocation) {
            (0, exports.UploadTracer)(null, { msg: "getLocationByBrowser - \u6D4F\u89C8\u5668\u5B9A\u4F4D\u5F02\u5E38", data: null }, startTime);
            console.log('当前浏览器不支持定位!1');
            resolve({ code: -1 });
        }
        window.navigator.geolocation.getCurrentPosition(function (position) {
            var location = {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
            };
            var bData = { code: 0, location: location };
            (0, exports.UploadTracer)(null, {
                msg: "getLocationByBrowser - \u6D4F\u89C8\u5668\u5B9A\u4F4D\u56DE\u8C03",
                data: JSON.stringify(bData),
            }, startTime);
            resolve(bData);
            console.log('定位成功!', location);
            return { code: 0, location: location };
        }, function (err) {
            (0, exports.UploadTracer)(null, {
                msg: "getLocationByBrowser - \u6D4F\u89C8\u5668\u5B9A\u4F4D\u5F02\u5E38Error",
                data: JSON.stringify(err),
            }, startTime);
            console.log('当前浏览器不支持定位!2', err);
            resolve({ code: -1 });
        }, {
            timeout: 5000, // 3 秒超时
        });
    });
};
exports.getLocationByBrowser = getLocationByBrowser;
/**
 * 钉钉
 * @returns {Promise} Promise
 */
var getLocationByDingTalk = function (initDDConfig) {
    if (initDDConfig === void 0) { initDDConfig = false; }
    return new Promise(function (resolve, reject) {
        var startTime = Date.now();
        if (initDDConfig) {
            (0, exports.getDDAuth)().then(function (res) {
                getDDLocationAuth(resolve, startTime);
            });
        }
        else {
            getDDLocationAuth(resolve, startTime);
        }
    });
};
exports.getLocationByDingTalk = getLocationByDingTalk;
function getDDLocationAuth(resolve, startTime) {
    dd.ready(function () {
        console.log('----------------------------dd.ready');
        dd.device.geolocation.get({
            targetAccuracy: Number,
            coordinate: Number,
            withReGeocode: Boolean,
            useCache: true,
            onSuccess: function (result) {
                console.log('----------------------------dd.result', result);
                var location = {
                    lat: result.latitude,
                    lng: result.longitude,
                };
                var ddData = { code: 0, location: location };
                (0, exports.UploadTracer)(null, {
                    msg: "getLocationByDingTalk - \u9489\u9489success",
                    data: JSON.stringify(ddData),
                }, startTime);
                resolve(ddData);
            },
            onFail: function (err) {
                console.log('----------------------------dd.onFail', err);
                (0, exports.UploadTracer)(null, {
                    msg: "getLocationByDingTalk - \u9489\u9489fail",
                    data: JSON.stringify(err),
                    type: 'error',
                }, startTime);
                resolve({ code: -1 });
                console.log('钉钉fail', err);
            },
        });
    });
    dd.error(function (err) {
        console.log('----------------------------dd.error', err);
        (0, exports.UploadTracer)(null, {
            msg: "getLocationByDingTalk - \u9489\u9489error",
            data: JSON.stringify(err),
            type: 'error',
        }, startTime);
        resolve({ code: -1 });
    });
}
/**
 * 支付宝定位
 * @returns  {Promise} Promise
 */
var getLocationByAlipayClient = function () {
    return new Promise(function (resolve, reject) {
        var startTime = Date.now();
        getAlipayLocation(resolve, startTime);
    });
};
exports.getLocationByAlipayClient = getLocationByAlipayClient;
function getAlipayLocation(resolve, startTime) {
    if (window.ap) {
        window.ap.getLocation(function (res) {
            if (res.error) { // 异常
                console.log('----------------------------Alipay.onFail', res.error);
                (0, exports.UploadTracer)(null, {
                    msg: "getAlipayLocation - \u652F\u4ED8\u5B9DFail",
                    data: JSON.stringify(res),
                    type: 'error',
                }, startTime);
                resolve({ code: -1 });
            }
            else { // 正常
                console.log('----------------------------Alipay.result', res);
                var location_1 = {
                    lat: res.latitude,
                    lng: res.longitude,
                };
                var aliData = { code: 0, location: location_1 };
                (0, exports.UploadTracer)(null, {
                    msg: "getAlipayLocation - \u652F\u4ED8\u5B9Dsuccess",
                    data: JSON.stringify(aliData),
                }, startTime);
                resolve(aliData);
            }
        });
    }
    else {
        console.log('----------------------------Alipay.onFail');
        (0, exports.UploadTracer)(null, {
            msg: "getAlipayLocation - \u652F\u4ED8\u5B9D",
            data: 'sdk 未初始化',
            type: 'error',
        }, startTime);
        resolve({ code: -1 });
    }
}
/**
 * 微信授权
 */
var getWXAuth = function () {
    return new Promise(function (resolve, reject) {
        var _a;
        var startTime = Date.now();
        // 1 微信 ; 2 企业微信
        var type = navigator.userAgent.match(/wxwork/i) ? 2 : 1;
        var api = new ApiHttpHelper();
        var unionCode = unionFlag() ||
            getSessionStorageDF('dffl_union') ||
            ((_a = window === null || window === void 0 ? void 0 : window.df_sdk_common) === null || _a === void 0 ? void 0 : _a.getCookieCompany()) ||
            null;
        if (unionCode === 'null') {
            unionCode = null;
        }
        api
            .Post2('/gw/app/permission_valid_config/signature', {
            caller: type,
            url: window.location.href.split('#')[0],
            union: unionCode
        })
            .then(function (data) {
            (0, exports.UploadTracer)(null, { msg: "getWXAuth - signature", data: JSON.stringify(data) }, startTime);
            console.log('signature', data);
            wx.config({
                debug: false,
                appId: data.Data.appId,
                timestamp: data.Data.timestamp,
                nonceStr: data.Data.nonceStr,
                signature: data.Data.signature,
                jsApiList: ['getLocation', 'scanQRCode'], // 必填，需要使用的JS接口列表
            });
            wx.ready(function (res) {
                resolve(__assign({ code: 0 }, data));
            });
            wx.error(function (res) {
                (0, exports.UploadTracer)(null, { msg: "getDFLocationByWX - \u5FAE\u4FE1error", data: JSON.stringify(res) }, startTime);
                resolve({ code: -1 });
                console.log('微信授权失败', res);
            });
        });
    });
};
exports.getWXAuth = getWXAuth;
/**
 * 钉钉鉴权
 * @returns
 */
var getDDAuth = function () {
    return new Promise(function (resolve, reject) {
        var _a, _b, _c;
        // 1 微信 ; 2 企业微信
        var isInternal = location.origin.includes('dev') ||
            ((_a = window === null || window === void 0 ? void 0 : window.df_sdk_common) === null || _a === void 0 ? void 0 : _a.env.isTest()) ||
            ((_b = window === null || window === void 0 ? void 0 : window.df_sdk_common) === null || _b === void 0 ? void 0 : _b.env.isStage());
        var _url = "https://".concat(isInternal ? 'adminstagenewbfd' : 'adminnewbfd', ".dongfangfuli.com/user/front/common/ding?url=").concat(encodeURIComponent(window.location.href.replace(/#.+?/, '')));
        var url = window.df_sdk_common ? (_c = window.df_sdk_common) === null || _c === void 0 ? void 0 : _c.grayDomain(_url) : url;
        var api = new ApiHttpHelper();
        api.Get(url, { skipDefaultErrorHandler: true }, false).then(function (res) {
            var _a, _b;
            if (((_a = res === null || res === void 0 ? void 0 : res.Data) === null || _a === void 0 ? void 0 : _a.code) == '0') {
                var _config = JSON.parse((_b = res === null || res === void 0 ? void 0 : res.Data) === null || _b === void 0 ? void 0 : _b.data);
                console.log('getDDAuth', _config);
                dd.config(__assign(__assign({}, _config), { agentId: _config === null || _config === void 0 ? void 0 : _config.agentId, corpId: _config === null || _config === void 0 ? void 0 : _config.corpId, timeStamp: _config === null || _config === void 0 ? void 0 : _config.timeStamp, nonceStr: _config === null || _config === void 0 ? void 0 : _config.nonceStr, signature: _config === null || _config === void 0 ? void 0 : _config.signature, jsApiList: ['device.geolocation.get', 'biz.util.scan'] }));
                resolve(__assign({ code: 0 }, res));
            }
            else {
                (0, exports.UploadTracer)(null, {
                    msg: "getLocationByDingTalk - \u9489\u9489fail",
                    data: JSON.stringify(res),
                    type: 'error',
                }, startTime);
                resolve({ code: -1 });
            }
        });
    });
};
exports.getDDAuth = getDDAuth;
/**
 * 判断是否是环境
 * @returns wx: 微信 / qywx: 企业微信 / bfdApp: 百福得app / maxApp: maxapp / browser: 普通浏览器 / dingtalk: 钉钉
 * @returns AlipayClient: 支付宝
 */
function checkEnv() {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return 'wx';
    }
    else if (ua.match(/WxWork/i) == 'wxwork') {
        return 'qywx';
    }
    else if (ua.indexOf('BFD-APP') > -1 ||
        window.navigator.userAgent.indexOf('BFD-APP') > -1) {
        return 'bfdApp';
    }
    else if (ua.indexOf('MAX-APP') > -1 ||
        window.navigator.userAgent.indexOf('MAX-APP') > -1) {
        return 'maxApp';
    }
    else if (ua.match(/DingTalk/i) == 'dingtalk') {
        return 'dingtalk';
    }
    else if (ua.match(/AlipayClient/i) == "alipayclient") {
        return 'AlipayClient';
    }
    else {
        return 'browser';
    }
}
exports.checkEnv = checkEnv;
/**
 * 清除缓存
 * @param key 键
 */
function removeLocalStorageDF(key) {
    var startTime = Date.now();
    var _win = window;
    _win.localStorage.removeItem(key);
    (0, exports.UploadTracer)(null, { msg: "removeLocalStorageDF - \u6E05\u9664\u4E86\u7F13\u5B58[".concat(key, "]"), data: null }, startTime);
}
exports.removeLocalStorageDF = removeLocalStorageDF;
/**
 * 获取定位
 * @param {Object[]} type - 是否指定定位方式,不传递默认浏览器定位.
 * @param {string} type - wx - 微信定位.
 * @param {string} type - bfdApp - 百福得app定位.
 * @param {string} type - maxApp - maxApp定位.
 * @param {string} type - AlipayClient - 支付宝定位.
 * @param {string} type - browser - 浏览器定位.
 * @param {requestCallback} cb - 执行后回调 返回对象DFLocationResponse.
 * @param {boolean} readCatch - 允许走缓存读取
 * @param {boolean} initConfig - 是否注册微信/钉钉 config 默认false
 */
var getLocation = function (type, cb, readCatch, initConfig) {
    if (type === void 0) { type = 'wx' | 'qywx' | 'bfdApp' | 'maxApp' | 'browser' | 'AlipayClient' | ''; }
    if (initConfig === void 0) { initConfig = false; }
    return __awaiter(void 0, void 0, void 0, function () {
        var startTime, cacheLocation, _val, cacheData, rData;
        return __generator(this, function (_a) {
            startTime = Date.now();
            cacheLocation = getSessionStorageDF(addressKeys === null || addressKeys === void 0 ? void 0 : addressKeys.location);
            if (cacheLocation && readCatch) {
                try {
                    _val = JSON.parse(cacheLocation);
                    if (_val && (_val.code === 200 || _val.code === 0)) {
                        cacheData = __assign({ type: 'cache' }, _val);
                        (0, exports.UploadTracer)(null, {
                            msg: "getLocation - \u7F13\u5B58\u5B9A\u4F4D[".concat(type, "}]"),
                            data: JSON.stringify(cacheData),
                            type: 'cache',
                        }, startTime);
                        return [2 /*return*/, cb && cb(cacheData)];
                    }
                    else {
                        // 失败的定位缓存或者垃圾缓存 全部清空
                        setSessionStorageDF(addressKeys === null || addressKeys === void 0 ? void 0 : addressKeys.location, '');
                    }
                }
                catch (ex) {
                    console.error('getLocation', ex);
                    // 失败的定位缓存或者垃圾缓存 全部清空
                    setSessionStorageDF(addressKeys === null || addressKeys === void 0 ? void 0 : addressKeys.location, '');
                    (0, exports.UploadTracer)(null, {
                        msg: "getLocation - \u7F13\u5B58\u5B9A\u4F4D\u5F02\u5E38[".concat(type, "}]"),
                        error: JSON.stringify(ex),
                        type: 'error',
                    }, startTime);
                }
            }
            rData = { type: type };
            switch (type) {
                case 'wx':
                case 'qywx':
                    (0, exports.getDFLocationByWX)(initConfig).then(function (value) {
                        rData = __assign(__assign({}, rData), value);
                        console.log(type + '微信&企业微信定位结果', rData);
                        cb && cb(rData);
                    });
                    break;
                case 'bfdApp':
                case 'maxApp':
                    (0, exports.getLocationByApp)().then(function (value) {
                        rData = __assign(__assign({}, rData), value);
                        console.log(type + '东福App定位结果', rData);
                        cb && cb(rData);
                    });
                    break;
                case 'dingtalk':
                    (0, exports.getLocationByDingTalk)(initConfig).then(function (value) {
                        rData = __assign(__assign({}, rData), value);
                        console.log(type + '钉钉定位结果', rData);
                        cb && cb(rData);
                    });
                    break;
                case 'AlipayClient':
                    (0, exports.getLocationByAlipayClient)(initConfig).then(function (value) {
                        rData = __assign(__assign({}, rData), value);
                        console.log(type + '支付宝定位结果', rData);
                        cb && cb(rData);
                    });
                    break;
                case 'browser':
                    (0, exports.getLocationByBrowser)().then(function (value) {
                        rData = __assign(__assign({}, rData), value);
                        console.log('浏览器定位结果', rData);
                        cb && cb(rData);
                    });
                    break;
                default:
                    break;
            }
            return [2 /*return*/];
        });
    });
};
exports.getLocation = getLocation;
/**
 *
 * @param {*} provinceId 省份ID
 * @param {*} provinceName 省份名称
 * @param {*} provinceNameValue 省份值
 * @param {*} cityId 城市ID
 * @param {*} cityName 城市名称
 * @param {*} cityNameValue 城市值
 * @param {*} districtId 区域ID
 * @param {*} districtName 区域名称
 * @param {*} districtValue 区域值
 * @param {*} streetId 街道ID
 * @param {*} streetName 街道名称
 * @param {*} streetValue 街道值
 * @param {*} other 自定义值
 * @param {*} PoiAddress 兴趣点
 */
var setCatchAddress = function (provinceId, provinceName, provinceNameValue, cityId, cityName, cityNameValue, districtId, districtName, districtValue, streetId, streetName, streetValue, id, other, PoiAddress) {
    if (PoiAddress === void 0) { PoiAddress = ''; }
    var startTime = Date.now();
    var cacheAddress = {
        // 省份ID
        provinceId: provinceId,
        // 省份名称
        provinceName: provinceName,
        // 省份值
        provinceNameValue: provinceNameValue,
        // 城市ID
        cityId: cityId,
        // 城市名称
        cityName: cityName,
        // 城市值
        cityNameValue: cityNameValue,
        // 区域ID
        districtId: districtId,
        // 区域ID
        regionId: districtId,
        // 区域名称
        districtName: districtName,
        districtValue: districtValue,
        // 街道ID
        streetId: streetId,
        // 街道名称
        streetName: streetName,
        streetValue: streetValue,
        id: id,
        other: other,
        PoiAddress: PoiAddress,
    };
    setLocalStorageDF('dfAddress', JSON.stringify(cacheAddress));
    oldAddressCompatible(cacheAddress);
    changeServiceCity(cityId);
    (0, exports.UploadTracer)(null, { msg: "setCatchAddress - \u66F4\u65B0\u7F13\u5B58", data: JSON.stringify(cacheAddress) }, startTime);
};
exports.setCatchAddress = setCatchAddress;
/**
 *
 * @returns address object - provinceId 省份ID
 * @returns address object - provinceName 省份名称
 * @returns address object - provinceNameValue 省份值
 * @returns address object - cityId 城市ID
 * @returns address object - cityName 城市名称
 * @returns address object - cityNameValue 城市值
 * @returns address object - districtId 区域ID
 * @returns address object - districtName 区域名称
 * @returns address object - districtValue 区域值
 * @returns address object - streetId 街道ID
 * @returns address object - streetName 街道名称
 * @returns address object - streetValue 街道值
 * @returns address object - other 自定义值
 * @returns address object - null 未获取到缓存
 */
var getCatchAddress = function () {
    // 东福统一定位地址
    var dfAddress = getLocalStorageDF('dfAddress');
    if (dfAddress) {
        return dfAddress;
    }
    else {
        return null;
    }
};
exports.getCatchAddress = getCatchAddress;
/**
 * 更新经纬度
 * @param lat
 * @param lng
 * @param upService 是否更新服务器端 默认false
 */
var setCatchLocation = function (lat, lng, upService) {
    if (upService === void 0) { upService = false; }
    var startTime = Date.now();
    var location = {
        location: {
            lat: lat,
            lng: lng,
        },
        type: 'custom',
        code: 0,
    };
    setSessionStorageDF(addressKeys === null || addressKeys === void 0 ? void 0 : addressKeys.location, JSON.stringify(location));
    (0, exports.UploadTracer)(null, { msg: "setCatchLocation - \u66F4\u65B0\u7F13\u5B58", data: JSON.stringify(location) }, startTime);
    if (upService) {
        loadAddressByLocation(lng, lat).then(function (res) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            if (res.Data.code === 200) {
                var resData = res.Data.data;
                setServiceLocationCatch(lng, lat, (_a = resData === null || resData === void 0 ? void 0 : resData.district) === null || _a === void 0 ? void 0 : _a.id, (_b = resData === null || resData === void 0 ? void 0 : resData.district) === null || _b === void 0 ? void 0 : _b.nameCh, (_c = resData === null || resData === void 0 ? void 0 : resData.city) === null || _c === void 0 ? void 0 : _c.id, (_d = resData === null || resData === void 0 ? void 0 : resData.city) === null || _d === void 0 ? void 0 : _d.nameCh, (_e = resData === null || resData === void 0 ? void 0 : resData.region) === null || _e === void 0 ? void 0 : _e.id, (_f = resData === null || resData === void 0 ? void 0 : resData.region) === null || _f === void 0 ? void 0 : _f.nameCh, (_g = resData === null || resData === void 0 ? void 0 : resData.street) === null || _g === void 0 ? void 0 : _g.id, (_h = resData === null || resData === void 0 ? void 0 : resData.street) === null || _h === void 0 ? void 0 : _h.nameCh, resData === null || resData === void 0 ? void 0 : resData.poiName, resData === null || resData === void 0 ? void 0 : resData.address);
                if (!((_j = resData === null || resData === void 0 ? void 0 : resData.district) === null || _j === void 0 ? void 0 : _j.id)) {
                    (0, exports.UploadTracer)(null, {
                        msg: "getLocationPoiUpload - getLocation - loadAddressByLocation",
                        data: JSON.stringify(resData),
                        type: 'error',
                    }, startTime);
                }
                else {
                    (0, exports.UploadTracer)(null, {
                        msg: "getLocationPoiUpload - getLocation - loadAddressByLocation",
                        data: JSON.stringify(resData),
                    }, startTime);
                }
            }
            else {
                (0, exports.UploadTracer)(null, {
                    msg: "getLocationPoiUpload - getLocation - loadAddressByLocation - \u89E3\u6790\u5F02\u5E38",
                    data: JSON.stringify(res),
                    type: 'error',
                }, startTime);
            }
        });
    }
};
exports.setCatchLocation = setCatchLocation;
/**
 * 根据IP获取位置
 * @returns promise
 */
var getLocationByIp = function () {
    var startTime = Date.now();
    var api = new ApiHttpHelper();
    var secretKey = 'XCwAjoB4';
    var cardCountParams = getParamsEncryption({}, '100060', secretKey);
    var res = api.Post('/gw/app/position/external/getAddressReParseInfo', cardCountParams);
    (0, exports.UploadTracer)(null, { msg: "getLocationByIp - Ip\u5B9A\u4F4D", data: JSON.stringify(res) }, startTime);
    return res;
};
exports.getLocationByIp = getLocationByIp;
/**
 * 解析经纬度地址
 * @param longitude 经度
 * @param latitude 纬度
 * @returns
 */
function loadAddressByLocation(longitude, latitude) {
    return new Promise(function (resolve, reject) {
        var startTime = Date.now();
        var secretKey = 'bsC2hc9m';
        var api = new ApiHttpHelper();
        var cardCountParams = getParamsEncryption({
            pageSize: 1,
            currentPage: 1,
            longitude: longitude,
            latitude: latitude,
            keywords: '',
        }, '100071', secretKey);
        var res = api.Post('/gw/app/position/external/pagePoi', cardCountParams);
        res.then(function (res) {
            var _a, _b, _c;
            var reBody = {
                code: res.Data.code,
            };
            if (((_b = (_a = res === null || res === void 0 ? void 0 : res.Data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.records) && ((_c = res.Data.data.records) === null || _c === void 0 ? void 0 : _c.length) > 0) {
                reBody.code = res.Data.code;
                reBody.data = res.Data.data.records[0];
            }
            resolve({ Data: reBody });
        });
    });
}
exports.loadAddressByLocation = loadAddressByLocation;
function loadAddressByCityId(cityId) {
    return new Promise(function (resolve, reject) {
        var startTime = Date.now();
        var secretKey = 'XCwAjoB4';
        var api = new ApiHttpHelper();
        var cardCountParams = getParamsEncryption({ cityId: cityId }, '100005', secretKey);
        var res = api.Post('/gw/app/position/external/getAddressReParseInfo', cardCountParams);
        res.then(function (data) {
            (0, exports.UploadTracer)(null, {
                msg: "loadAddressByCityId - \u57CE\u5E02\u53CD\u89E3\u6790\u7ECF\u7EAC\u5EA6",
                data: JSON.stringify(data),
            }, startTime);
        });
        resolve(res);
    });
}
exports.loadAddressByCityId = loadAddressByCityId;
/**
 * 判断当前浏览器是否授权定位
 * @returns true/false
 */
function checkBrowser() {
    return new Promise(function (resolve, reject) {
        try {
            if (window.navigator.permissions === undefined) {
                resolve(false);
                return;
            }
            window.navigator.permissions
                .query({ name: 'geolocation' })
                .then(function (PermissionStatus) {
                if ('granted' === PermissionStatus.state) {
                    resolve(true);
                }
                else {
                    resolve(false);
                }
            });
        }
        catch (ex) {
            resolve(false);
        }
    });
}
exports.checkBrowser = checkBrowser;
/**
 * 持久化经纬度与兴趣点
 * @param longitude 经度
 * @param latitude 纬度
 * @param {*} provinceId 省份ID
 * @param {*} provinceName 省份名称
 * @param {*} cityId 城市ID
 * @param {*} cityName 城市名称
 * @param {*} districtId 区域ID
 * @param {*} districtName 区域名称
 * @param {*} streetId 街道ID
 * @param {*} streetName 街道名称
 * @param poiName poi名称
 * @param address 地址
 * @returns
 */
function setServiceLocationCatch(longitude, latitude, provinceId, provinceName, cityId, cityName, regionId, regionName, streetId, streetName, poiName, address) {
    return new Promise(function (resolve, reject) {
        var api = new ApiHttpHelper();
        var params = {
            longitude: longitude,
            latitude: latitude,
            provinceId: provinceId,
            provinceName: provinceName,
            cityId: cityId,
            cityName: cityName,
            regionId: regionId,
            regionName: regionName,
            streetId: streetId,
            streetName: streetName,
            poiName: poiName,
            address: address,
        };
        var res = api.Post('/df-gw/location/lbs/saveuserlocation', params);
        res.then(function (data) {
            resolve(data);
        });
    });
}
exports.setServiceLocationCatch = setServiceLocationCatch;
/**
 * 获取服务器持久经纬度与兴趣点
 * @param pageSize 获取条数,默认1条,最大15条
 * @param defualtChangeLocation 是否开启静默更新定位, 默认不开启
 * @returns
 */
function getServiceLocation(pageSize, defaultChangeLocation) {
    if (pageSize === void 0) { pageSize = 1; }
    if (defaultChangeLocation === void 0) { defaultChangeLocation = false; }
    return new Promise(function (resolve, reject) {
        var _a;
        var startTime = Date.now();
        var secretKey = 'XCwAjoB4';
        var api = new ApiHttpHelper();
        var unionCode = ((_a = window === null || window === void 0 ? void 0 : window.df_sdk_common) === null || _a === void 0 ? void 0 : _a.getCookieCompany()) || unionFlag() || getSessionStorageDF('dffl_union');
        var params = { pageSize: pageSize };
        var cardCountParams = getParamsEncryption(params, '100005', secretKey, unionCode);
        var res = api.Post2('/gw/app/user/location/query', cardCountParams);
        res.then(function (data) {
            if (defaultChangeLocation) {
                getLocationPoiUpload();
            }
            resolve(data);
        });
    });
}
exports.getServiceLocation = getServiceLocation;
/**
 * 获取定位与兴趣点并上传至服务器持久化
 * @param uploadService 是否要同步至服务器,默认true
 * @returns
 */
function getLocationPoiUpload(uploadService) {
    if (uploadService === void 0) { uploadService = true; }
    return new Promise(function (resolve, reject) {
        var startTime = Date.now();
        var env = checkEnv();
        (0, exports.getLocation)(env, function (data) {
            // UploadTracer(
            //   null,
            //   {
            //     msg: `getLocationPoiUpload - getLocation - 定位方式[${env}]`,
            //     data: JSON.stringify(data),
            //   },
            //   startTime
            // )
            if ((data === null || data === void 0 ? void 0 : data.code) === 0) {
                loadAddressByLocation(data.location.lng, data.location.lat).then(function (res) {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                    if (res.Data.code === 200) {
                        var resData = res.Data.data;
                        if (uploadService) {
                            setServiceLocationCatch(data.location.lng, data.location.lat, (_a = resData === null || resData === void 0 ? void 0 : resData.district) === null || _a === void 0 ? void 0 : _a.id, (_b = resData === null || resData === void 0 ? void 0 : resData.district) === null || _b === void 0 ? void 0 : _b.nameCh, (_c = resData === null || resData === void 0 ? void 0 : resData.city) === null || _c === void 0 ? void 0 : _c.id, (_d = resData === null || resData === void 0 ? void 0 : resData.city) === null || _d === void 0 ? void 0 : _d.nameCh, (_e = resData === null || resData === void 0 ? void 0 : resData.region) === null || _e === void 0 ? void 0 : _e.id, (_f = resData === null || resData === void 0 ? void 0 : resData.region) === null || _f === void 0 ? void 0 : _f.nameCh, (_g = resData === null || resData === void 0 ? void 0 : resData.street) === null || _g === void 0 ? void 0 : _g.id, (_h = resData === null || resData === void 0 ? void 0 : resData.street) === null || _h === void 0 ? void 0 : _h.nameCh, resData === null || resData === void 0 ? void 0 : resData.poiName, resData === null || resData === void 0 ? void 0 : resData.address);
                        }
                        if (!((_j = resData === null || resData === void 0 ? void 0 : resData.district) === null || _j === void 0 ? void 0 : _j.id)) {
                            (0, exports.UploadTracer)(null, {
                                msg: "getLocationPoiUpload - getLocation - loadAddressByLocation",
                                data: JSON.stringify(resData),
                                type: 'error',
                            }, startTime);
                        }
                        else {
                            (0, exports.UploadTracer)(null, {
                                msg: "getLocationPoiUpload - getLocation - loadAddressByLocation",
                                data: JSON.stringify(resData),
                            }, startTime);
                        }
                        resolve(__assign({ code: 0 }, data));
                    }
                    else {
                        resolve({
                            code: 1,
                            data: {
                                lng: data.location.lng,
                                lat: data.location.lat,
                                msg: '获取poi异常',
                            },
                        });
                    }
                });
            }
            else {
                resolve({ code: 1, data: {} });
            }
        });
    });
}
exports.getLocationPoiUpload = getLocationPoiUpload;
/**
 * 上报日志
 * @param key 指定key 默认dflocationsdk_log
 * @param upContent 自定义上报内容
 */
var UploadTracer = function (key, upContent, startTime) {
    if (upContent === void 0) { upContent = {}; }
    try {
        // 如果存在 DFTracer
        if (window.DFTracer) {
            window.DFTracer.local(key || logKey, function () {
                var sessionStorage = window.sessionStorage;
                var pageUrl = window.location.href;
                var tTime = {};
                if (startTime) {
                    var time = sumTime(startTime);
                    tTime = time;
                }
                window.DFTracer.setTags(__assign(__assign(__assign(__assign({}, tTime), checkTerminal()), upContent), { pageUrl: pageUrl }) || {});
            });
        }
    }
    catch (ex) {
        console.error('调用链异常', ex);
    }
};
exports.UploadTracer = UploadTracer;
/**
 * 判断工会头
 */
function unionFlag() {
    var currentUnionValue;
    var union = getUrlParams('union');
    var pathname = window.location.pathname;
    if (union) {
        // URI带union参数的判断是工会链接
        return union;
    }
    if (/^corp/.test(pathname) && pathname.match(/union\/\w+/g)) {
        var val = pathname.match(/union\/\w+/g);
        currentUnionValue = val && val.length > 0 ? val[0].split('/')[1] : '';
    }
    else {
        return currentUnionValue;
    }
}
exports.unionFlag = unionFlag;
var locationSDK = {
    initAddressDF: exports.initAddressDF,
    getCatchAddress: exports.getCatchAddress,
    setCatchAddress: exports.setCatchAddress,
    getLocation: exports.getLocation,
    removeLocalStorageDF: removeLocalStorageDF,
    checkEnv: checkEnv,
    getLocationByApp: exports.getLocationByApp,
    getDFLocationByWX: exports.getDFLocationByWX,
    getLocationByAlipayClient: exports.getLocationByAlipayClient,
    getLocationByBrowser: exports.getLocationByBrowser,
    getWXAuth: exports.getWXAuth,
    setCatchLocation: exports.setCatchLocation,
    getLocationByIp: exports.getLocationByIp,
    getLocationPoiUpload: getLocationPoiUpload,
    getServiceLocation: getServiceLocation,
    setServiceLocationCatch: setServiceLocationCatch,
};
exports.default = locationSDK;
